import { FC, ReactElement } from 'react';

import { AutoCashoutConnected } from '../../components/autoCashout';
import { Bets } from '../../config/bets';

import { CrashAutoplayModalConnectedV2 } from './autoplayV2/CrashAutoplayModalConnectedV2';
import { CrashAutoPlayConnected } from './CrashAutoPlayConnected';
import { UndoControlConnected } from './UndoControlConnected/UndoControlConnected';

import styles from './bettingFooterConnected.module.css';

export interface BettingFooterConnectedProps {
  betCode: Bets;
}
export const BettingFooterConnected: FC<BettingFooterConnectedProps> = ({ betCode }): ReactElement => {
  return (
    <div className={styles.betting_footer}>
      <div className={styles.left_control_section}>
        <UndoControlConnected betCode={betCode} />
        <CrashAutoPlayConnected betCode={betCode} />
      </div>
      <AutoCashoutConnected betCode={betCode} />
      <div className={styles.autoPlay_drawer_cell}>
        <CrashAutoplayModalConnectedV2 betId={betCode} />
      </div>
    </div>
  );
};
